import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var LoaderContext = /** @class */ (function (_super) {
    __extends(LoaderContext, _super);
    function LoaderContext(checkPolicyFile, applicationDomain, securityDomain) {
        if (checkPolicyFile === void 0) { checkPolicyFile = false; }
        if (applicationDomain === void 0) { applicationDomain = null; }
        if (securityDomain === void 0) { securityDomain = null; }
        var _this = _super.call(this) || this;
        _this._applicationDomain = applicationDomain;
        return _this;
    }
    Object.defineProperty(LoaderContext.prototype, "applicationDomain", {
        get: function () {
            return this._applicationDomain;
        },
        set: function (value) {
            this._applicationDomain = value;
        },
        enumerable: true,
        configurable: true
    });
    return LoaderContext;
}(ASObject));
export { LoaderContext };
